import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const NOTIFICATION_TEMPLATES_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/notification-templates',
        iconClass: 'fas fa-file-invoice',
        name: 'Notification Templates',
        layout: eLayoutType.application,
        requiredPolicy: 'TTB.Routing',
        order: 5,
        group: 'Global Setup',
      },
    ]);
  };
}
